import styled from '@emotion/styled';
import { percentageFormatter } from '@dnhb/formatters';
import PropTypes from 'prop-types';
import FilterSvg from 'images/shared/filter.svg';
import { FilterButton } from 'shared/components/FilterDropdown';

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  min-height: 32px;
  width: 100%;
  margin-bottom: 8px;

  h1 {
    font-size: 14px;
    font-weight: 800;
    line-height: 16px;
    color: ${({ theme }) => theme.primaryColor};
    padding-right: 8px;

    span {
      white-space: nowrap;
    }
  }
  
  > button {
    flex-shrink: 0;
  }
`;

const Header = ({ nhg, ltv, setShowFilters }) => (
  <HeaderContainer>
    <h1>
      Gebaseerd op <span>{nhg ? 'NHG' : `${percentageFormatter(ltv, 0)} marktwaarde`}</span>
    </h1>
    <FilterButton onClick={() => setShowFilters(true)}>
      <FilterSvg />
    </FilterButton>
  </HeaderContainer>
);

export default Header;

Header.propTypes = {
  nhg: PropTypes.bool.isRequired,
  ltv: PropTypes.number.isRequired,
  setShowFilters: PropTypes.func.isRequired,
};
